<template>
  <vs-row>
    <vs-col vs-lg="9" vs-sm="12" class="p-2">
      <UserInfo :teacherPersonalDetails="teacherPersonalDetails" />
    </vs-col>
    <vs-col vs-lg="3" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div class="flex flex-wrap justify-between items-center mb-2">
          <h4>Attach Tag</h4>
        </div>
        <v-select
          append-to-body
          class="w-full"
          label="name"
          taggable
          :create-option="
            (option) => ({ id: option, label: option, name: option })
          "
          :options="tagModuleWise"
          v-model="tagSelected"
          @input="checkingTagChanges(teacher_id)"
          :clearable="false"
          data-vv-name="tag_list"
          name="tag_list"
          multiple
          placeholder="Type and press enter to create a tag and then attach it."
        >
        </v-select>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <h4>Personal Bio</h4>
        </div>
        <div>
          <vs-tabs class="one_line_tab_label">
            <vs-tab label="Personal Bio">
              <PersonalBio :setAfterUpdate="setAfterUpdate" :havePermission="havePermission('user_personal_bio')" :teacherPersonalDetails="teacherPersonalDetails" />
            </vs-tab>
            <vs-tab label="Education">
              <Education
              @setAfterUpdate="setAfterUpdate" :havePermission="havePermission('user_education')"
                :educationProps="teacherPersonalDetails.educations"
                :teacherPersonalDetails="teacherPersonalDetails"
              />
            </vs-tab>
            <vs-tab label="Language"> 
            <Language @setAfterUpdate="setAfterUpdate" :havePermission="havePermission('user_languages')"  :languageProps="teacherPersonalDetails.languages" :teacherPersonalDetails="teacherPersonalDetails" />
             </vs-tab>
            <vs-tab label="Award"> 
              <Award @setAfterUpdate="setAfterUpdate" :havePermission="havePermission('user_awards')"  :awardProps="teacherPersonalDetails.awards" :teacherPersonalDetails="teacherPersonalDetails" />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div class="flex flex-wrap justify-between items-center mb-4">
          <h4>Contact Information</h4>
        </div>
        <div>
          <vs-tabs class="information_tab_holder">
            <vs-tab label="Email">
              <Email
                :havePermission="havePermission('user_emails')"
                :emailProps="teacherPersonalDetails.email"
                :teacherPersonalDetails="teacherPersonalDetails"
                @setAfterUpdate="setAfterUpdate"
              />
            </vs-tab>
            <vs-tab label="Phone">
              <Phone
                :havePermission="havePermission('user_phones')"
                :phoneProps="teacherPersonalDetails.phone"
                :teacherPersonalDetails="teacherPersonalDetails"
                @setAfterUpdate="setAfterUpdate"
              />
            </vs-tab>
            <vs-tab label="Address">
              <Address
              :havePermission="havePermission('user_address')"
                :addressProps="teacherPersonalDetails.address"
                :teacherPersonalDetails="teacherPersonalDetails"
                @setAfterUpdate="setAfterUpdate"
              />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-w="12" class="p-2">
      <vs-card>
        <div class="flex flex-wrap justify-between items-center mb-4">
          <h4>Additional Information</h4>
        </div>
        <AdditionalInfoComponent :dynamicfields="dynamicfields" :teacherPersonalDetails="teacherPersonalDetails" @setAfterUpdate="setAfterUpdate" />

               
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { Tag } from '@/mixins/tag/tag'

import vSelect from 'vue-select'
import UserInfo from '../account/user_info.vue'

import PersonalBio from '@/views/pages/v1/user_profile/components/profile/personal_information/personal_bio.vue'
import Education from '@/views/pages/v1/user_profile/components/profile/personal_information/education.vue'
import Language from '@/views/pages/v1/user_profile/components/profile/personal_information/language.vue'
import Award from '@/views/pages/v1/user_profile/components/profile/personal_information/award.vue'

import Email from '@/views/pages/v1/user_profile/components/profile/contact_information/email.vue'
import Phone from '@/views/pages/v1/user_profile/components/profile/contact_information/phone.vue'
import Address from '@/views/pages/v1/user_profile/components/profile/contact_information/address.vue'

import AdditionalInfoComponent from  '@/views/pages/v1/user_profile/components/profile/additionalInfo.vue'


export default {
  mixins: [PermissionMiddleware, Tag],
  props: {
    teacherPersonalDetails: {
      default: {}
    },
    dynamicfields: {
      default: {}
    },
    havePermission:{
      default () {}
    }
  },
  mounted () {
    this.fetchTag(this.platform_module_id, this.teacherPersonalDetails.tags)
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  watch: {
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    }
  },
  data () {
    return {
      showMore: true,
      platform_module_id: 38,
      teacher_id: this.$route.params.teacher_id
    }
  },
  components: {
    vSelect,
    UserInfo,
    PersonalBio,
    Email,
    Phone,
    Address,
    Education,
    Language,
    Award,
    AdditionalInfoComponent
  },
  methods: {
    setAfterUpdate (data) {
      this.$emit('setAfterUpdate', data)
    },
    removeTag (index) {
      this.tagSelected = this.tagSelected.filter((ele) => ele.id !== index)
    }
  }
}
</script>